import React, { useEffect } from "react";
import "./index.css"; // Custom CSS file
import HeroSwiper from "./sections/HeroSwiper";
import InfoStrip from "./sections/InfoStrip";
import FeatureCards from "./sections/FeatureCards";
import MarketOverview from "../../components/MarketOverview";
import WhyChooseUs from "./sections/WhyChooseUs";
import BannerCta from "./sections/BannerCta";
import PopupSlider from "./sections/PopupSlider";

import {
  ContactLocations,
  // StockMarketWidget,
  TradingTools,
} from "../home_old_notinuse";
// import InquiryForm from "../../components/Inquiry-form";
// import { TrickerWidget } from "../../pages/horizantalWidget";
// import  StockTicker  from "../../components/Ticker";
import PSXTicker from "../../components/PSXTicker";

// C:\Users\amjad\Documents\GitHub\orbit_web\src\pages\horizantalWidget.js
export default function NewHome() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-in");
        }
      });
    }, observerOptions);

    document.querySelectorAll(".animate").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
  return (
   
   <div className="new-home-container">
      {/* ── Popup slider (renders only when active popups exist) ── */}
      <PopupSlider />

      {/* ── Section 1: Hero image swiper ── */}
      <HeroSwiper />

      {/* ── Section 2: Interactive info strip ── */}
      <InfoStrip />

      {/* ── Section 3: Feature cards ── */}
      <FeatureCards />

      {/* ── Section 4: Market overview (volume leaders / gainers / losers) ── */}
      <section className="home-market-overview">
        <h2 className="home-section-title">Market Overview</h2>
        <MarketOverview viewAll="/market-overview" />
      </section>
      {/* little gap */}

      {/* ── Section 5: Why Choose Us ── */}
      <WhyChooseUs />


      {/* <TrickerWidget /> */}
 

      {/* <StockMarketWidget /> */}
      <TradingTools />
      <ContactLocations />

      {/* ── Banner CTA (just before footer) ── */}
      <BannerCta />
    </div>
  );
}
